import { DateTime } from "luxon";

const DEFAULT_LOCALE = "en-GB";

export function canonicalizeLocale(locale?: string | null): string {
  if (!locale) return DEFAULT_LOCALE;
  try {
    return new Intl.DateTimeFormat(locale).resolvedOptions().locale || DEFAULT_LOCALE;
  } catch {
    return DEFAULT_LOCALE;
  }
}

function normalizeDateInput(value: Date | string | null | undefined): Date | null {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;

  const parsedDate = new Date(value);
  if (!Number.isNaN(parsedDate.getTime())) {
    return parsedDate;
  }

  const parsedIso = DateTime.fromISO(value, { zone: "utc" });
  if (parsedIso.isValid) return parsedIso.toJSDate();

  return null;
}

export function formatDateForUserLocale(value: Date | string | null | undefined, locale?: string | null): string {
  const date = normalizeDateInput(value);
  if (!date) return "";
  const userLocale = canonicalizeLocale(locale);
  return new Intl.DateTimeFormat(userLocale, { dateStyle: "short" }).format(date);
}

export function formatDateForUserLocaleStyle(
  value: Date | string | null | undefined,
  locale?: string | null,
  style: "short" | "medium" | "long" | "full" = "short"
): string {
  const date = normalizeDateInput(value);
  if (!date) return "";
  const userLocale = canonicalizeLocale(locale);
  return new Intl.DateTimeFormat(userLocale, { dateStyle: style }).format(date);
}

export function formatDateTimeForUserLocale(value: Date | string | null | undefined, locale?: string | null): string {
  const date = normalizeDateInput(value);
  if (!date) return "";
  const userLocale = canonicalizeLocale(locale);
  return new Intl.DateTimeFormat(userLocale, {
    dateStyle: "short",
    timeStyle: "short",
  }).format(date);
}
